import React from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

const DemandAnimal = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="thailand-market-container">
        <div className="thailand-market-grid">
          <Link
            className="global-market-menuitem"
            to="/thailand-market/quantity-animal"
          >
            ปริมาณตัวสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/demand-animal"
          >
            ความต้องการอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/share-market"
          >
            ส่วนแบ่งการตลาดอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/sale-animal"
          >
            ยอดขายอาหารสัตว์ CPF
          </Link>
        </div>
        <div className="quantity-animal-title">
          ความต้องการอาหารสัตว์ประเทศไทย
        </div>
        <table className="quantity-animal-table">
          <tr>
            <th>ประเภท</th>
            <th>2019</th>
            <th>2020</th>
            <th>2021</th>
            <th>2022</th>
            <th>2023</th>
            <th style={{ display: "flex", flexDirection: "column" }}>
              <div>%เติบโต</div>
              <div>2022-2023</div>
            </th>
          </tr>
          <tr>
            <td>ลูกไก่เนื้อ</td>
            <td>6.66</td>
            <td>6.68</td>
            <td>6.52</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>6.95</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>7.25</td>
            <td>4%</td>
          </tr>
          <tr>
            <td>ไก่ไข่</td>
            <td>2.42</td>
            <td>2.34</td>
            <td>2.39</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>2.42</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>2.46</td>
            <td>2%</td>
          </tr>
          <tr>
            <td>สุกร</td>
            <td>5.83</td>
            <td>5.89</td>
            <td>4.85</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>4.44</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>5.28</td>
            <td>19%</td>
          </tr>
          <tr>
            <td>อื่นๆ</td>
            <td>2.27</td>
            <td>2.34</td>
            <td>2.30</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>2.31</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>2.37</td>
            <td>2%</td>
          </tr>
          <tr>
            <td>รวม</td>
            <td>17.18</td>
            <td>17.26</td>
            <td>16.05</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>16.13</td>
            <td style={{ backgroundColor: "#e6f1e0" }}>17.35</td>
            <td>8%</td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default DemandAnimal;
